import React from "react";
import { NavLink, useSearchParams } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
// import SupportImage1 from '../1a.png';
// import SupportImage2 from '../2a.png';
// import SupportImage3 from '../3a.png';


// <Image src={SupportImage1} rounded align="left" />
// <Image src={SupportImage2} rounded align="left" />
// <Image src={SupportImage3} rounded align="left" style={{ width: "90px", height: "90px" }}/>

const SearchType = () => {
    let [searchParams, setSearchParams] = useSearchParams();
    let project_id = searchParams.get("projectid")
    return (
        <Container>
            <Row>
                <Col>
                    <br />
                    <h1 className="center-align">Select Type of Search</h1>
                </Col>
            </Row>
            <Row>
                <Col>
                    <br />
                    <h2 className="title">PROJECTS WITH LARGE FILES (UP TO 50 MB)</h2>
                </Col> 
           </Row>
           <Row>
                <Col>
                    <p className="search-option">
                        <br />
                        <NavLink to={"/querysearch?projectid=" + project_id}>
                            <span className="title">Query Search</span>
                        </NavLink>
                        <span className="description"><br />Get answers you need by asking questions using natural language. Conduct "Google Like" queries to retrieve specific information from your document data set. For example, ask "Where is the service desk located?".</span>
                    </p>
                </Col>
            </Row>
           <Row>
                <Col>
                    <br />
                    <h2 className="title">PROJECTS WITH SMALL FILES (UP TO 500 KB)</h2>
                </Col> 
            </Row>
            <Row>
                <Col>
                    <p className="search-option">
                        <br />
                        <NavLink to={"/keywordsearch?projectid=" + project_id}>
                            <span className="title">Keyword Search </span>
                        </NavLink>
                        <span className="description"><br />Search for specific keyword text or key phrases amongst all the documents in your data set simultaneously, then create a keyword summary report</span>
                    </p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className="search-option">
                        <br />
                        <NavLink to={"/entitysearch?projectid=" + project_id}>
                            <span className="title">Entity Search</span>
                        </NavLink>
                        <span className="description"><br />Not sure what your searching for? Search your document data set for specific Entities. Select an entity type from the dropdown menu and start your search. For example, conduct an entity search for "Name" to create a list of all people named in your document data set, along with their reference documents. Then create an entity summary report. You can also use this tool to create an event timeline for your business case.</span>
                    </p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className="search-option">
                        <br />
                        <NavLink to={"/querysearch?projectid=" + project_id}>
                            <span className="title">Query Search</span>
                        </NavLink>
                        <span className="description"><br />Get answers you need by asking questions using natural language. Conduct "Google Like" queries to retrieve specific information from your document data set. For example, ask "Where is the service desk located?".</span>
                    </p>
                </Col>
            </Row>
        </Container>
    );
};
export default SearchType;